// /contexts/codeLocationKiosk.js
import React, { createContext, useContext, useEffect, useState } from "react";
import {collection, getDocs, onSnapshot } from 'firebase/firestore';
import { kioskDB } from 'utils/firebase';


const LocationContext = createContext();

export const LocationProviderKiosk = ({ children }) => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let unsubscribe = null;

    const fetchInitialCodes = async () => {
      try {
        // 1️⃣ 로컬 캐시 확인
        const cached = localStorage.getItem("locationCodes");
        if (cached) {
          setLocations(JSON.parse(cached));
        }

        // 2️⃣ Firestore에서 최신 데이터 가져오기
        const querySnapshot = await getDocs(collection(kioskDB, "GPS_LOCATION"));
        const fetched = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setLocations(fetched);
        localStorage.setItem("locationCodes", JSON.stringify(fetched));

        // 3️⃣ Firestore 실시간 구독
        unsubscribe = onSnapshot(collection(kioskDB, "GPS_LOCATION"), (snapshot) => {
          const updatedLocations = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          // 4️⃣ 추가·수정뿐 아니라 삭제도 즉시 반영
          setLocations(updatedLocations);
          localStorage.setItem("locationCodes", JSON.stringify(updatedLocations));
        });
      } catch (error) {
        console.error("Error fetching initial codes:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchInitialCodes();

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, []);

  return (
    <LocationContext.Provider value={{ locations, loading }}>
      {children}
    </LocationContext.Provider>
  );
};

export const useLocationsKiosk = () => useContext(LocationContext);

